import React from 'react';
import Lottie from 'lottie-react';
import "./Main_wallet_card_lottie.css";

function Main_wallet_card_lottie({animationData}) {
  return (
    <section className='Main_wallet_card_lottie'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  );
}

export default Main_wallet_card_lottie;
